// `Org.created_via` vocabulary — must stay in sync with the backend `Org.CreatedVia` text
// choices (power_backend/org/models.py). Read-only everywhere on the frontend: the field is
// system-derived (org/self_serve.py, or the site-admin/partner create views) and marked
// read_only on SiteAdminOrgSerializer, so nothing here ever writes it — only labels it for
// the site-admin review surface (self-serve-org-signup task 6.1's frontend half).
export const CREATED_VIA_OPTIONS = [
    { value: 'self_serve', label: 'Self-serve signup' },
    { value: 'partner', label: 'Partner' },
    { value: 'site_admin', label: 'Site admin' }
]

export function createdViaLabel(value) {
    return (
        CREATED_VIA_OPTIONS.find((opt) => opt.value === value)?.label ??
        value ??
        'Site admin'
    )
}

// Self-serve is the source that wants a human's attention (an org nobody here provisioned) —
// give it a distinct colour rather than blending in with the other two.
export function createdViaChipColor(value) {
    if (value === 'self_serve') return 'warning'
    if (value === 'partner') return 'info'
    return 'default'
}
